
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//   1234 Save transaction
// Removed deprecated @angular/http import as it is no longer used.
import { RefundDetails, FinanceVP, Transaction, CommentsDetails } from '@accountexecutivemodel/AccountExecutive';
// Removed duplicate import of HttpHeaders
import { environment } from '@environment/environment';
import { SaveTransaction } from '@externalusermodel/Order';
import { GetEnvVarService } from "../../service/get-env-var.service";
//    Save transaction
import { Options } from '../../../../node_modules/@types/selenium-webdriver/opera';
@Injectable()
export class AccountExecutiveService {

  storedAccessJwtToken = sessionStorage.getItem('token');
  private baseUrl: string;
  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
  }
  // Method to get Finance VP Details
  getFinanceVPs() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`})
      let options = { headers: headers };
    return this.http.get(this.baseUrl + `/api/Refund/FinanceVP`, options).pipe(
      map(response => response as FinanceVP[]),
      catchError(handleError),);
  }
  // Method to get Refund Details
  getRefundDetails() {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`})
      let options = { headers: headers };
    return this.http.get(this.baseUrl + `/api/Refund`, options).pipe(
      map(response => response as RefundDetails[]),
      catchError(handleError),);
  }
  // Method to update refund details
  saveRefundDetails(RefundDetailsModel, currentTrancationID): Observable<any> {
debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/SaveRefundDetails/` + currentTrancationID, JSON.stringify(RefundDetailsModel), options).pipe(
      map(response => response as any));
  }
  // Method to get transaction Details
  getTransactionDetails(UserID: any, Period: any, isshowtransChecked: boolean): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.storedAccessJwtToken}`})
      let options = { headers: headers };
    return this.http.get(this.baseUrl + `/api/Transaction/` + UserID + `/` + Period + `/` + isshowtransChecked,options).pipe(
      map(response => response as Transaction[]),
      catchError(handleError),);
  }
  getComments(refundDetailsID: any): Observable<any> {
    return this.http.get(this.baseUrl + `/api/GetComments/` + refundDetailsID).pipe(
      map(response => response as CommentsDetails[]),
      catchError(handleError),);
  }
  saveComments(CommentsModel: any): Observable<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/SaveComments/`, JSON.stringify(CommentsModel), options).pipe(
      map(response => response as any),
      catchError(handleError),);
  }
    //To get Refund Calculation
    getRefundCalculation(amount: any, paymentType: any, type: any, invoiceID: any, orderID: any): Observable<any> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.storedAccessJwtToken}`
      });
      let options = { headers: headers };
      return this.http.get(this.baseUrl + `/api/RefundCalc/` + amount + `/` + paymentType + `/` + type + `/` + invoiceID + `/` + orderID, options).pipe(
        map(response => response as any),
        catchError(handleError),
      );
    }

      //   Method to get transaction Details by date.
  getTransactionDetailsDate(UserID: any, value1: Date, value2: Date, isshowtransChecked: boolean): Observable<any> {
    debugger;
    return this.http.get(this.baseUrl + `/api/SearchTransaction/` + UserID + `/` + isshowtransChecked + `/` + value1 + `/` + value2).pipe(
      map(response => response as Transaction[]),
      catchError(handleError),);
  }
//   1234 for save Transaction 
saveTransaction(requestData: SaveTransaction): Observable<any> {
   debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //let headers = new Headers({ 'Content-Type': 'application/json' });
  let options = { headers: headers };
  //let test = JSON.stringify(requestData);
 return this.http.put(this.baseUrl + `/api/order/saveTransaction`, JSON.stringify(requestData), options).pipe(
            map(response => response as any),
            catchError(handleError),);
  }

}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);
  // throw an application level error
  return observableThrowError(errorMsg);
}
